import cn from "classnames";
import { ChangeEventHandler, useState } from "react";

import * as S from "./range-slider.styled";
const MIN = 2;
const MAX = 20;

const getStep = (max: number) => {
  if (max > 10) {
    return 0.5;
  }
  if (max > 5) {
    return 0.2;
  }
  return 0.1;
};

const RangeSlider = ({
  title,
  value,
  min = MIN,
  max = MAX,
  handleChange,
  onTouchStart,
  className,
  minBlocked,
  isCritical,
}: {
  title: string;
  value: number;
  minBlocked?: number;
  min?: number;
  max?: number;
  handleChange?: ChangeEventHandler<HTMLInputElement>;
  onTouchStart?: () => void;
  className?: string;
  isCritical?: boolean;
}) => {
  const [active, setActive] = useState(false);

  return (
    <S.SuperSlider
      active={active}
      className={cn(className, { [S.CRITICAL_CLASS]: isCritical })}
      title={title}
      value={value}
      restrictLessThan={minBlocked}
      max={max}
      min={min}
      step={getStep(max)}
      onChange={handleChange}
      onTouchStart={() => {
        setActive(true);
        onTouchStart && onTouchStart();
      }}
      onTouchEnd={() => setActive(false)}
    />
  );
};

export default RangeSlider;
